'use client'
import styles from '@/app/styles/components/pages/cart/payment-details.module.scss'
import {useState} from "react";
import CartProcessStep from "@/app/constants/CartProcessStep";
import {FormattedMessage} from "react-intl";
import {createOrder, updateOrder} from "@/app/services/OrderService";
import {useDispatch, useSelector} from "react-redux";
import {useRouter} from "next/navigation";
import {emptyCart} from "@/app/services/CartService";
import {clearCartData, updateCart, updateCartData} from "@/app/slices/CartSlice";
import {useSession} from "next-auth/react";
import {event} from "@/gtag";

const PaymentDetails = ({data, cart, changeStep}) => {
    const {data: session} = useSession()
    const router = useRouter()
    const dispatch = useDispatch()
    const transportationInfo = useSelector((state) => state.cart.data)
    const deliveryMethod = useSelector((state) => state.cart.deliveryMethod)
    const deliveryPrice = useSelector((state) => state.cart.deliveryPrice)
    const [selectedPaymentGateway, setSelectedPaymentGateway] = useState()
    const handlePaymentGatewayClick = (paymentGateway) => {
        setSelectedPaymentGateway(paymentGateway)
    }
    const [paymentPossible,setPaymentPossible] = useState(true)

    const mapProducts = (cart) => {
        const cartItems = Object.keys(cart).reduce((acc, product_id) => {
            const quantity = cart[product_id];
            acc.push({product_id: parseInt(product_id), quantity});
            return acc;
        }, []);
        return cartItems;
    }

    const handlePay = async () => {
        const {id, title} = selectedPaymentGateway
        const {deliveryData, senderData} = transportationInfo
        let requestData = {
            payment_method: id,
            payment_method_title: title,
            set_paid: false,
            billing: senderData,
            shipping: deliveryData,
            line_items: mapProducts(cart),
            status: id === 'bacs' ? 'on-hold' : 'processing',
            shipping_lines: [
                {
                    method_id: deliveryMethod.id,
                    method_title: deliveryMethod.title,
                    total: deliveryPrice.toString()
                }
            ],
        };

        if(session?.user?.id) {
            requestData = {
                ...requestData,
                customer_id: session?.user?.id
            }
        }

        // We need this logic because the date formatter component will not handle otherwise
        const initialDate = deliveryData.date;
        const dateParts = initialDate.split(".")
        const formattedDate = `${dateParts[2]}${dateParts[1]}${dateParts[0]}`
        //
        setPaymentPossible(false)

        const response = await createOrder({data: requestData})

        event('conversion', {
            transaction_id: response.id,
            status: response.status,
            currency: 'RSD',
            value: response.total,
            customerId: response.customer_id,
            billingFirstName: response.billing.first_name,
            billingLastName: response.billing.last_name,
            billingEmail: response.billing.email,
            billingPhone: response.billing.phone,
            shippingFirstName: response.shipping.first_name,
            shippingLastName: response.shipping.last_name,
            shippingEmail: response.shipping.email,
            shippingPhone: response.shipping.phone,
            shippingAddress: response.shipping.address_1,
            shippingCity: response.shipping.city,
            paymentMethod: response.payment_method,
            number: response.number
        })

        await updateOrder({
            id: response.id,
            data: {
                meta_data: [{key: 'delivery_date', value: formattedDate}, {key: 'delivery_time', value: deliveryData.time !== '' ? deliveryData.time : 'Bilo kad'}]
            }
        })

        await emptyCart()
        dispatch(updateCart({data:{},uuid:'payment'}))
        dispatch(clearCartData())
        const params = new URLSearchParams({customerName: response.billing.first_name,orderId: response.id}).toString();
        router.push(`/zavrsena-kupovina/${response.id}`)

    }
    return (
        <>
            {data && data.paymentGateways ?
                <div className={styles.paymentDetailsContainer}>
                    {data.paymentGateways.map((item, idx) => {
                        return item.enabled ? (
                            <div key={idx}
                                 className={selectedPaymentGateway?.id === item.id ? styles.itemSelected : styles.item}
                                 onClick={() => handlePaymentGatewayClick(item)}>
                                <div className={styles.header}>
                                    <div className={styles.title}>
                                        <span className={styles.radio}>
                                            <span className={styles.radioInside}></span>
                                        </span>
                                        <label>{item.title}</label>
                                    </div>
                                </div>
                                <div className={styles.description}>
                                    <p>{item.description}</p>
                                    <div className={styles.controls}>
                                        <button onClick={() => changeStep(CartProcessStep.SENDER)}
                                                className={styles.btnLight}>
                                            <FormattedMessage id={'components.pages.cart.cartDetails.back'}/>
                                        </button>
                                        <button onClick={handlePay} className={styles.btn} disabled={!paymentPossible}>
                                            {paymentPossible ? <FormattedMessage id={'components.pages.cart.cartDetails.payAndClose'}/> : <FormattedMessage id={'components.pages.cart.cartDetails.wait'}/>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : null
                    })}
                </div> : null
            }
        </>)
}

export default PaymentDetails
